import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import Color from './Color';
import Material from './Material';
import Pattern from './Pattern';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1300px !important;
  padding-top: 20px;

  .filters {
    width: 100%;
    display: flex;
  }

  .grid-buttons {
    display: flex;
  }
`;

function Filter({
  doubleGrid,
  setDoubleGrid,
  colors,
  colorIds,
  setColorIds,
  materialIds,
  setMaterialIds,
  patternIds,
  setPatternIds,
  patterns,
  materials,
  setSaveDoubleGrid
}) {
  const match = useRouteMatch();
  const isWallpaper = match.params.categorySlug.toLowerCase() === 'wallpaper';

  const isOutdoor = ['outdoor', 'lampshades'].includes(
    match.params.categorySlug.toLowerCase()
  );

  const clearFilters = () => {
    setMaterialIds([]);
    setPatternIds([]);
    setColorIds([]);
  };

  const handleGrid = isDoubleGrid => {
    setDoubleGrid(isDoubleGrid);
    setSaveDoubleGrid(true);
  };

  const showClear = materialIds.length || patternIds.length || colorIds.length;

  return (
    <Wrapper className="container">
      <div className="filters">
        <Color colors={colors} colorIds={colorIds} setColorIds={setColorIds} />
        {!isWallpaper && (
          <>
            {patterns.length > 1 && (
              <Pattern
                patterns={patterns}
                patternIds={patternIds}
                setPatternIds={setPatternIds}
              />
            )}

            {/*{!isOutdoor && materials.length > 1 && (*/}
            {/*  <Material*/}
            {/*    materials={materials}*/}
            {/*    materialIds={materialIds}*/}
            {/*    setMaterialIds={setMaterialIds}*/}
            {/*  />*/}
            {/*)}*/}
          </>
        )}
      </div>

      <ClearFilterButton showClear={showClear} onClick={clearFilters}>
        Clear All
      </ClearFilterButton>

      {!isWallpaper && (
        <div className="grid-buttons">
          <DoubleGridIcon
            selected={doubleGrid === true}
            src="/assets/category/double_grid.svg"
            className="double-grid"
            onClick={() => handleGrid(true)}
          />
          <SingleGridIcon
            src="/assets/category/single_grid.svg"
            className="double-grid"
            selected={doubleGrid === false}
            onClick={() => handleGrid(false)}
          />
        </div>
      )}
    </Wrapper>
  );
}

export default Filter;

const DoubleGrid = styled.svg`
  margin-right: 10px;
  cursor: pointer;
  width: 45px;
  rect {
    stroke: ${({ selected }) => (selected ? '#2A5CAF' : '#C4C4C4')};
  }
`;

const ClearFilterButton = styled.button`
  visibility: ${({ showClear }) => (showClear ? 'visible' : 'hidden')};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.04em;
  color: #a83569;
  border: none;
  outline: none;
  background: white;
  width: 100px;
  margin-right: 15px;
`;
export const DoubleGridIcon = ({ className, onClick, selected }) => {
  return (
    <DoubleGrid
      selected={selected}
      onClick={onClick}
      className={className}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="55"
        height="55"
        rx="1.5"
        fill="white"
        stroke="#2A5CAF"
      />
      <rect
        x="15.3569"
        y="14.2142"
        width="11.5714"
        height="11.5714"
        rx="1.5"
        fill="white"
        stroke="#2A5CAF"
      />
      <rect
        x="15.3569"
        y="29.0714"
        width="11.5714"
        height="11.5714"
        rx="1.5"
        fill="white"
        stroke="#2A5CAF"
      />
      <rect
        x="30.2144"
        y="14.2142"
        width="11.5714"
        height="11.5714"
        rx="1.5"
        fill="white"
        stroke="#2A5CAF"
      />
      <rect
        x="30.2144"
        y="29.0714"
        width="11.5714"
        height="11.5714"
        rx="1.5"
        fill="white"
        stroke="#2A5CAF"
      />
    </DoubleGrid>
  );
};

const SingleGrid = styled.svg`
  cursor: pointer;
  width: 45px;
  rect {
    stroke: ${({ selected }) => (selected ? '#2A5CAF' : '#C4C4C4')};
  }
`;

export const SingleGridIcon = ({ className, onClick, selected }) => {
  return (
    <SingleGrid
      selected={selected}
      onClick={onClick}
      className={className}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="55"
        height="55"
        rx="1.5"
        fill="white"
        stroke="#C4C4C4"
      />
      <rect
        x="22.2144"
        y="14.2142"
        width="11.5714"
        height="11.5714"
        rx="1.5"
        fill="white"
        stroke="#C4C4C4"
      />
      <rect
        x="22.2144"
        y="29.0714"
        width="11.5714"
        height="11.5714"
        rx="1.5"
        fill="white"
        stroke="#C4C4C4"
      />
    </SingleGrid>
  );
};
